<script>
import {
  productCategoryItemAbonnementProps,
  useProductCategoryItemAbonnement
} from "./mixin";
import ListItem from "@/components/molecules/list/list-item";
import LazyImage from "@/components/atoms/lazy-image";
import LinkTo from "@/components/atoms/link-to";
import Button from "@/components/atoms/button";
import CartSelector from "@/containers/panier/abonnement-lad/cart-selector";
import HtmlParser from "@/components/organisms/cms-container/html-parser";
import { useProductDetailsTracking } from "@/mixins/tracking/product-details";
import { usePageMerchAboLad } from "@/components/pages/mixins/merch-abo-lad";

export default {
  name: "ProductCategoryItem",
  components: {
    ListItem,
    LazyImage,
    LinkTo,
    Button,
    CartSelector,
    HtmlParser
  },
  props: {
    ...productCategoryItemAbonnementProps()
  },
  emits: ["removeItem"],
  setup(props) {
    const { aboladcodes, getAboLadData, merchAboLad } = usePageMerchAboLad();
    const { prix } = useProductCategoryItemAbonnement(props);
    const { trackProductPage } = useProductDetailsTracking();
    return { prix, trackProductPage, aboladcodes, getAboLadData, merchAboLad };
  }
};
</script>

<template>
  <ListItem class="c-product-category-item c-product-category-item--abonnement">
    <HtmlParser
      v-if="getAboLadData(aboladcodes.DESCRIPTION_OFFRE_HTML)"
      :content="getAboLadData(aboladcodes.DESCRIPTION_OFFRE_HTML)"
      class="u-mb-md u-mt-xs"
    />
    <div class="u-text-right u-mb-xxs u-mb-sm@lg">
      <Button
        link
        variant="grey-3"
        @click="$emit('removeItem')"
      >
        <span class="u-font-13">Supprimer</span>
      </Button>
    </div>
    <div class="c-product-category-item__line">
      <LazyImage
        :src="article.visuel"
        :dimension="96"
        height="80"
        width="80"
        class="c-product-category-item__image"
      />
      <div class="c-product-category-item__infos">
        <div class="c-product-category-item__description">
          <LinkTo
            to="/abonnement-livraison"
            class="c-product-category-item__title"
          >
            {{ truncate(article.designation, 60) }}
          </LinkTo>
          <p class="c-product-category-item__subtitle">
            {{ article.abonnement.duree }} {{ article.abonnement.unite }}
          </p>
        </div>
        <div class="c-product-category-item__infos-wrap">
          <template v-if="article.en_stock">
            <CartSelector
              :abonnement="article"
              :show-button="false"
              dropdown-size="sm"
              panier
              class="u-mr-md"
            />

            <div class="c-product-category-item__price-summary">
              <p
                v-if="article.prix_barre && !article.prix_avec_remise_sans_appel_fidelite"
                class="c-product-category-item__price-crossed"
              >
                {{ formatPrix(article.prix_barre) }}&nbsp;€
              </p>
              <p class="c-product-category-item__price-total">
                {{ formatPrix(prix) }}&nbsp;€
              </p>
            </div>
          </template>
          <template v-else>
            <div class="c-product-category-item__buttons">
              <Button
                variant="primary"
                radius="full"
                size="xs"
                link
                to="/abonnement-livraison"
              >
                <span class="u-font-400">Voir les autres formules</span>
              </Button>
            </div>
          </template>
        </div>
      </div>
    </div>
  </ListItem>
</template>

<style scoped lang="scss">
@import "@/assets/styles/components/product-category-item.scss";
</style>
